import { ChangeDetectorRef, Component, ElementRef, ViewChild } from "@angular/core";
import { BaseFormComponent } from "../../../../projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { DriverAssignmentRead } from "../order/model/invoice.model";
import { DriverAssignementService } from "./driverassignment.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { SimpleMenuComponent } from "./settingment";
import { ContextMenuEnum } from "../order/model/contextMenuenum";
import { ContextMenuService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/context-menu.service";
import { take } from "rxjs/operators";
import { SaleMethodBranchModel, SaleMethodNature } from "../sales/model/sale-method-branch.model";
import { FormGroup, FormControl } from "@angular/forms";
import { ExternalNotification, ExternalNotificationStateKindEnum } from "./external-notification.model";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";

@Component({
  selector: "order-driverassignment",
  templateUrl: "./driverassignment.component.html",
  styleUrls: ["./driverassignment.component.scss"],
  providers: [DriverAssignementService],
})
export class DriverAssignmentComponent extends BaseFormComponent<DriverAssignmentRead> {
  menu = SimpleMenuComponent;
  public contextmenuEnum: typeof ContextMenuEnum = ContextMenuEnum;
  public ExternalNotificationStateKindEnum: typeof ExternalNotificationStateKindEnum = ExternalNotificationStateKindEnum;
  safirToken: string | null = null;
  notificationIndex: number;
  mapForm: FormGroup = new FormGroup({
    Token: new FormControl(null),
    BranchDes: new FormControl(null),
    BranchLng: new FormControl(null),
    BranchLat: new FormControl(null),
    BranchCode: new FormControl(null),
    SystemCode: new FormControl(null),
  });

  @ViewChild("scrollTarget") private scrollTarget: ElementRef;

  constructor(
    public driverservice: DriverAssignementService,
    public contextMenuService: ContextMenuService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    __id: FormContainerModel,
    private el: ElementRef
  ) {
    super(selectorService, cd);
    this.apiName = "Invoice";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.DriverAssignment.Payment");
    this.driverservice._id = __id.metadata.id;
    this.driverservice.inputSearch = "searchInput" + __id.metadata.id;
    this.driverservice.inputBarCode = "barcodeInput" + __id.metadata.id;
    this.driverservice.setFormGroupValue();
  }

  async ngOnInit() {
    await super.ngOnInit();
    const authService = this.accountService.authService;
    const SystemCode = authService.currentInformation().LockNumber;
    const currentBranch = authService.currentBranch;
    this.safirToken = authService.currentInformation().SafirToken;
    if (this.safirToken) this.driverservice.getExternalNotification();
    this.mapForm.patchValue({
      Token: this.safirToken,
      BranchDes: "",
      BranchLng: currentBranch.Longitude ?? 0,
      BranchLat: currentBranch.Latitude ?? 0,
      BranchCode: currentBranch.Id,
      SystemCode: SystemCode,
    });

    this.httpCommonService
      .getList("Invoice/GetSaleMethodBranchMenu")
      .pipe(take(1))
      .subscribe((data: SaleMethodBranchModel[]) => {
        this.driverservice.deliverySaleMethodData = data.filter((x) => x.SaleMethodNatureCode === SaleMethodNature.Delivery);
        this.driverservice.focus();
      });
  }

  onMapClick() {
    this.driverservice.showFleetMap = true;
    setTimeout(() => {
      const submitEl = this.el.nativeElement.querySelector(".submit");
      if (submitEl) submitEl.click();
    }, 50);
  }

  onNotificationClick() {
    this.driverservice.showFleetMap = false;
    this.driverservice.showNotification = true;
    this.selectNotification(this.driverservice.notificationList[0]);
  }

  selectNotification(notification: any) {
    this.notificationIndex = this.driverservice.notificationList.findIndex((x) => x.PersonnelId === notification.PersonnelId);
    this.driverservice.seenNotification(notification);
    setTimeout(() => {
      this.scrollTarget.nativeElement.scrollIntoView();
    }, 10);
  }

  notificationTrackBy(index: number, notification: ExternalNotification): number {
    return notification.Id;
  }
}
